/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUserIntentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_user_intent.pb'
import {GetUserIntentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_user_intent.pb'


export const getUserIntent = (request: GetUserIntentRequest, options?: CashRequestOptions) => post<GetUserIntentRequest, GetUserIntentResponse>("/cash-app/local/user-intent/get", request, {...options, rejectOnError: true })